<svelte:head>
  <script
    src="https://kit.fontawesome.com/fd0436766f.js"
    crossorigin="anonymous"></script>
</svelte:head>
